export function getEnv(key: string) {
  return process.env[key]
}

export function getAppEnv(key: string) {
  return getEnv(`REACT_APP_${key}`)
}

export default {
  app: {
    baseUrl: getAppEnv('BASEURL'),
  },

  auth0: {
    clientIdPasswordless: getAppEnv('AUTH0_CLIENT_ID_PASSWORDLESS'),
    clientId: getAppEnv('AUTH0_CLIENT_ID'),
    domain: getAppEnv('AUTH0_DOMAIN'),
    audience: getAppEnv('AUTH0_AUDIENCE'),
    realm: getAppEnv('AUTH0_REALM'),
    scopes: getAppEnv('AUTH0_SCOPES'),
    realmLimited: getAppEnv('AUTH0_REALM_LIMITED'),
  },

  imageToPdfApi: {
    apiUrl: getAppEnv('IMAGE_PDF_API_URL'),
    apiKey: getAppEnv('IMAGE_PDF_API_KEY')
  },

  sentry: {
    dsn: getAppEnv('SENTRY_DSN'),
  },

  services: {
    maps: {
      baseUrl: getAppEnv('MAPS_URL'),
    },
    identity: {
      baseUrl: getAppEnv('IDENTITY_URL'),
    },
    data: {
      baseUrl: getAppEnv('DATA_URL'),
    },
    progress: {
      baseUrl: getAppEnv('PROGRESS_URL'),
    },
  },
  trackingLink: {
    qrScanFeatureCutoffDate: getAppEnv('QRSCAN_FEATURE_CUTOFF_DATE'),
  }
}
